const ProgressBarNew = ({
  title,
  percent,
  color,
  emissionValue,
  unit,
  proportion,
}) => {
  return (
    <>
      <style jsx>{`
        .progress_barnew_title {
          font-weight: 400;
          font-size: 0.37rem;
          color: #333333;
          display: flex;
          justify-content: space-between;
        }
        .progress_barnew_bg_box {
          height: 0.43rem;
          margin-top: 0.1rem;
          background: #ebebeb;
          overflow: hidden;
        }
        .progress_barnew_bg {
          height: 0.43rem;
          background: #03bf8a;
        }
        .progress_barnew {
          margin-top: 0.32rem;
        }
        .percent_float {
          font-weight: 400;
          font-size: 0.27rem;
          color: #333333;
          text-align: right;
          position: absolute;
          margin-top: -0.02rem;
          right: 0.6rem;
        }
        .font_nowrap {
          white-space: nowrap;
        }
      `}</style>
      <div className="progress_barnew">
        <div className="progress_barnew_title">
          <p>{title}</p>
          <span>
            <span className="font_nowrap">
              {emissionValue} {unit}
            </span>
          </span>
        </div>
        <div className="progress_barnew_bg_box">
          <span className="percent_float">{proportion || 0}%</span>
          <div
            className="progress_barnew_bg"
            style={{ width: (percent || 0) + "%", background: color }}
          ></div>
        </div>
      </div>
    </>
  );
};
export default ProgressBarNew;
